// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* In-app loading overlay - separate from splash screen */

#loading-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
  background: rgba(0, 0, 0, 0.6);
  justify-content: center;
  align-items: center;
}

#loading-overlay-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--color-dark-background, #1f1f1f);
  border: 1px solid var(--color-dark-border, #3a3a3a);
  border-radius: 12px;
  padding: 24px 32px;
  min-width: 260px;
  max-width: 360px;
  text-align: center;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
}

#loading-overlay-spinner {
  display: inline-block;
  width: 32px;
  height: 32px;
  border: 3px solid var(--color-dark-border, #3a3a3a);
  border-top-color: var(--color-primary, #ba160c);
  border-radius: 50%;
  animation: loading-overlay-spin 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes loading-overlay-spin {
  to {
    transform: rotate(360deg);
  }
}

#loading-overlay-text {
  color: #ffffff;
  font-size: 0.95rem;
  line-height: 1.4;
  font-family: 'Open Sans', sans-serif;
}`, "",{"version":3,"sources":["webpack://./public/css/loading-overlay.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iDAAiD;EACjD,mDAAmD;EACnD,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,+CAA+C;EAC/C,kBAAkB;EAClB,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC","sourcesContent":["/* In-app loading overlay - separate from splash screen */\n\n#loading-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 101;\n  background: rgba(0, 0, 0, 0.6);\n  justify-content: center;\n  align-items: center;\n}\n\n#loading-overlay-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: var(--color-dark-background, #1f1f1f);\n  border: 1px solid var(--color-dark-border, #3a3a3a);\n  border-radius: 12px;\n  padding: 24px 32px;\n  min-width: 260px;\n  max-width: 360px;\n  text-align: center;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);\n}\n\n#loading-overlay-spinner {\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--color-dark-border, #3a3a3a);\n  border-top-color: var(--color-primary, #ba160c);\n  border-radius: 50%;\n  animation: loading-overlay-spin 0.8s linear infinite;\n  margin-bottom: 12px;\n}\n\n@keyframes loading-overlay-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n#loading-overlay-text {\n  color: #ffffff;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  font-family: 'Open Sans', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
